"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwIfMissingBaseUrlEnvVar = void 0;
const throwIfMissingBaseUrlEnvVar = (serviceUrlEnvKey) => {
    const value = process.env[serviceUrlEnvKey];
    if (!value) {
        throw new Error(`Missing ENV var '${serviceUrlEnvKey}' for the service URL`);
    }
    return value;
};
exports.throwIfMissingBaseUrlEnvVar = throwIfMissingBaseUrlEnvVar;
//# sourceMappingURL=throwIfMissingBaseUrlEnvVar.js.map